var _module = require('../../components/module');
var _ = require('lodash');

require('angular-ui-router');
require('angular-local-storage');
require('../confirmation-modal');
require('../analytics');

_module.service('$mlsAcceptToC', [
    '$log',
    '$q',
    '$http',
    '$timeout',
    '$state',
    'localStorageService',
    '$confirmationModal',
    '$analytics',

    function MLSAcceptToCService($log, $q, $http, $timeout, $state, localStorageService, $confirmationModal, $analytics) {
        function MLSAcceptToC() {
            this.loading = true;
            this.zipcodes = {};
            this.alreadyApprovedMLSs = [];
            this._currentlyOpenModal;

            this._fetchAlreadyApprovedMLSs();
            this._fetchZipCodesThatRequireToC()
            .finally(function () {
                this.loading = false;
            }.bind(this));
        }

        // Private Functions
        MLSAcceptToC.prototype._fetchZipCodesThatRequireToC = function fetchZipCodesThatRequireToC() {
            return $http.get('/v1/mls/toc-by-zipcode')
            .then(function (response) {
                this.zipcodes = response.data.data;
            }.bind(this));
        };

        MLSAcceptToC.prototype._fetchAlreadyApprovedMLSs = function fetchAlreadyApprovedMLSs() {
            this.alreadyApprovedMLSs = localStorageService.get('mlstocapproved') || [];
        };

        MLSAcceptToC.prototype._acceptMLSToC = function acceptMLSToC(mlsData) {
            this.alreadyApprovedMLSs.push(mlsData.mls);
            localStorageService.set('mlstocapproved', this.alreadyApprovedMLSs);
        };

        MLSAcceptToC.prototype._needsApproval = function needsApproval(mlss) {
            var mlsData = mlss.shift();

            if(this._currentlyOpenModal) {
                this._currentlyOpenModal.$close();
            }

            if(mlsData) {
                $analytics.eventTrack('nest_accept_terms_modal_displayed', {
                    mls: mlsData.mls
                });

                var modal = this._currentlyOpenModal = $confirmationModal({
                    title: 'Terms & Conditions',
                    message: 'Please accept the following <a href="' + mlsData.toc + '" target="_blank" class="btn btn-link btn-nopad" style="font-size: 16px; border: 0; position :relative; top: -2px;">terms & conditions</a> from ' + mlsData.mls,
                    buttons: {
                        ok: {
                            label: 'Accept'
                        },
                        cancel: {
                            visible: true,
                            label: 'Decline'
                        }
                    },
                    modalOptions: {
                        keyboard: false,
                        backdrop: 'static',
                        backdropClass: 'mls-accept-toc-backdrop'
                    }
                });

                modal
                .result
                .then(function (response) {
                    if(response) {
                        $analytics.eventTrack('nest_accept_terms_modal_accept_clicked', {
                            mls: mlsData.mls
                        });
                        this._acceptMLSToC(mlsData);
                        $timeout(this._needsApproval.bind(this), 200, true, mlss);
                    } else {
                        $analytics.eventTrack('nest_accept_terms_modal_decline_clicked', {
                            mls: mlsData.mls
                        });
                        $state.go('homepage', { preventSearchFilterRedirect: true });
                    }
                }.bind(this))
                .finally(function () {
                    this._currentlyOpenModal = undefined;
                }.bind(this));
            }
        };

        // Public Functions

        MLSAcceptToC.prototype.checkZipCodes = function checkZipCodes(zipCodes) {
            var alreadyApprovedMLSs = this.alreadyApprovedMLSs;

            if(this.loading) {
                return $timeout(this.checkZipCodes.bind(this), 1000, true, zipCodes);
            }

            if(!_.isArray(zipCodes)) zipCodes = [zipCodes];

            var mlssThatNeedApproval = zipCodes.reduce(function (result, zipcode) {
                var mlsInfo = this.zipcodes[zipcode];

                if(mlsInfo && !~alreadyApprovedMLSs.indexOf(mlsInfo.mls)) {
                    result[mlsInfo.mls] = mlsInfo;
                }

                return result;
            }.bind(this), {});
            mlssThatNeedApproval = _.values(mlssThatNeedApproval);

            if(mlssThatNeedApproval.length) {
                this._needsApproval(mlssThatNeedApproval);
            }
        };

        return new MLSAcceptToC();
    }
]);
